import { AnimatedGradientText } from '@mcdougald/ui/src';
import { type ReactNode } from 'react';

import { cn } from '../../libraries/tailwind/cn';

type SectionHeadingProps = {
  children: ReactNode;
};
type AuroraSectionHeadingProps = {
  children: ReactNode;
  className?: string;
};

const HEADER_COLORS2 = [
  '#DADADA',
  '#D4D4D4',
  '#CECECE',
  '#C8C8C8',
  '#C2C2C2',
  '#BCBCBC',
];
const dark = '#919191';

const HEADER_COLORS = [
  '#E8E8E8',
  '#E4E4E4',
  '#E0E0E0',
  '#DCDCDC',
  '#D8D8D8',
  '#D4D4D4',
];
export const AuroraSectionHeading = ({
  children,
  className = '',
}: Readonly<AuroraSectionHeadingProps>) => {
  return (
    <AnimatedGradientText
      colorTo={dark}
      colorFrom={HEADER_COLORS[0]}
      className={cn('section-header text-4xl', className)}
    >
      {children}
    </AnimatedGradientText>
    // <AuroraText colors={HEADER_COLORS} speed={2} className={cn('section-header text-3xl', className)}>
    //   {children}
    // </AuroraText>
  );
};

export default function SectionHeading({
  children,
}: Readonly<SectionHeadingProps>) {
  return (
    <h2 className="section-header text-3xl font-medium capitalize mb-8 text-center">
      {children}
    </h2>
  );
}
